import { message } from "antd";
import {
  DELETE_PLATFORM,
  GET_PLATFORM,
  PATCH_PLATFORM,
  PUT_PLATFORM,
  POST_PLATFORM,
} from "../apis/apis";

const { makeAutoObservable } = require("mobx");

class LearningGraphStore {
  constructor() {
    makeAutoObservable(this);
  }

  loading = false;
  learningGraphs = [];
  learningCount = null;
  learningGraph = null;
  educationalOutcomes = [];

  catalogueItems = [];
  materials = [];

  setLoading(value) {
    this.loading = value;
  }

  setLearningGraphs(values) {
    this.learningGraphs = values;
  }

  setLearningCount(value) {
    this.learningCount = value;
  }

  setLearningGraph(value) {
    this.learningGraph = value;
  }

  setEducationalOutcomes(values) {
    this.educationalOutcomes = values;
  }

  setCatalogueItems(values) {
    this.setCatalogueItems(values);
  }
  setMaterials(values) {
    this.materials = values;
  }

  GetLearningGraphs = async (page) => {
    try {
      this.setLoading(true);
      const data = await GET_PLATFORM(`/learning-graph?page=${page}`);
      this.setLearningGraphs(data.results);
      this.setLearningCount(data.count);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetFilteredLearningGraphs = async (searchTerm) => {
    try {
      this.setLoading(true);
      const data = await GET_PLATFORM(`/learning-graph?search=${searchTerm}`);
      this.setLearningGraphs(data.results);
      this.setLearningCount(data.count);
      // this.setLearningGraphs(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetLearningGraphsByLevel = async (level) => {
    try {
      const data = await GET_PLATFORM(`/learning-graph/${level}`);
      this.setLearningGraphs(data.results);
      this.setLearningCount(data.count);
      // this.setLearningGraphs(data);
    } catch (error) {
      console.error(error);
    }
  };

  GetLearningGraph = async (id) => {
    try {
      const data = await GET_PLATFORM(`/learning-graph/${id}`);
      return data;
      this.setLearningGraph(data);
    } catch (error) {
      console.error(error);
    }
  };

  PostLearningGraph = async (values) => {
    try {
      await POST_PLATFORM(`/learning-graph`, values);
      await this.GetLearningGraphs(1);
      message.success("Item created successfully");
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  PatchLearningGraph = async (id, values) => {
    try {
      const data = await PATCH_PLATFORM(`/learning-graph/${id}`, values);
      await this.GetLearningGraphs();
      message.success("Item updated successfully");
      this.setLearningGraph(data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  PutLearningGraph = async (id, values) => {
    try {
      const data = await PUT_PLATFORM(`/learning-graph/${id}`, values);
      await this.GetLearningGraphs(1);
      message.success("Item updated successfully");
      this.setLearningGraph(data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  UpdateLearningGraphProgress = async (currentPage, id, values) => {
    console.log(currentPage);
    console.log(id);
    try {
      const data = await PUT_PLATFORM(`/learning-graph/${id}/progress`, values);
      await this.GetLearningGraphs(currentPage);
      message.success("Item updated successfully");
      this.setLearningGraph(data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  DeleteLearningGraph = async (id) => {
    try {
      const data = await DELETE_PLATFORM(`/learning-graph/${id}`);
      this.setLearningGraph(data);
      message.success("Item deleted successfully");
      await this.GetLearningGraphs(1);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  GetEducationalOutcome = async () => {
    try {
      const data = await GET_PLATFORM(`/educational-outcome`);
      console.log(data);
      let arrayOfOutcomes = data.results.map((out) => out.educational_outcome);
      console.log(arrayOfOutcomes);
      this.setEducationalOutcomes({
        educational_outcomes: arrayOfOutcomes,
      });
    } catch (error) {
      console.error(error);
    }
  };

  GetEducationalOutcomesAndMaterials = async () => {
    try {
      const data = await GET_PLATFORM(`/educational-outcome`);
      console.log(data);
      // let arrayOfOutcomes = data.results.map((out) => out.educational_outcome);
      let arrayOfOutcomes = data.map((out) => out.educational_outcome);
      console.log(arrayOfOutcomes);
      this.setEducationalOutcomes({
        educational_outcomes: arrayOfOutcomes,
      });
      const materials = await Promise.all(
        arrayOfOutcomes?.map((outcome) => this.GetCatalogueByOutcome(outcome)),
      );

      // .flatMap((item) => item.results);

      this.setMaterials(materials.flatMap((item) => item.results));
      console.log(materials.flatMap((item) => item.results));
      console.log(this.materials);
    } catch (error) {
      console.error(error);
    }
  };

  GetFilteredEducationalOutcome = async (name) => {
    try {
      const data = await GET_PLATFORM(`/educational-outcome/${name}`);

      // this.setEducationalOutcomes(data.results);
      this.setEducationalOutcomes(data);
    } catch (error) {
      console.error(error);
    }
  };

  GetCatalogueByOutcome = async (educationalOutcome) => {
    try {
      const data = await GET_PLATFORM(
        `/catalogue-item/outcome/${educationalOutcome}`,
      );
      return data;
    } catch (error) {
      console.error(error);
      return { results: [] };
    }
  };
}

export { LearningGraphStore };
